import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  mainList: { data: [], loading: false },
  stopList: { data: [], loading: false },
  synonymList: { data: [], loading: false },
  schList: { data: [], loading: false },
  docList: { data: [], loading: false },
  checkList: { data: [], success: false, loading: false },
  dialog: { title: '', action: '', visible: false, loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
